import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { POPOVER_PADDING_X, POPOVER_PADDING_Y, SHEPHERD_PADDING_Y, TOOLTIP_LONGFORM_PADDING, TOOLTIP_PADDING_X, TOOLTIP_PADDING_Y } from 'HubStyleTokens/sizes';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import styled, { css } from 'styled-components';
import { PopoverContext } from '../context/PopoverContext';
const Body = styled.div.withConfig({
  displayName: "UIPopoverBody__Body",
  componentId: "sc-1xk1xvw-0"
})(["background:inherit;padding:", ";", ";"], ({
  flush,
  popoverUse
}) => {
  if (flush) return '0';
  if (popoverUse === 'longform') return `0 ${TOOLTIP_LONGFORM_PADDING} 1px`;
  if (popoverUse === 'shepherd') return `${SHEPHERD_PADDING_Y} ${POPOVER_PADDING_X}`;
  if (popoverUse.includes('tooltip')) return `${TOOLTIP_PADDING_Y} ${TOOLTIP_PADDING_X}`;
  return `${POPOVER_PADDING_Y} ${POPOVER_PADDING_X} 0`;
}, ({
  popoverUse
}) => {
  if (popoverUse === 'shepherd') return css(["border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;"]);
  if (popoverUse.includes('tooltip')) return css(["border-radius:inherit;line-height:1.5;"]);
  return null;
});
export default function UIPopoverBody(_ref) {
  let {
    className
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["className"]);

  return /*#__PURE__*/_jsx(Body, Object.assign({}, rest, {
    className: classNames('uiPopoverBody private-popover__body', className),
    popoverUse: useContext(PopoverContext).use
  }));
}
UIPopoverBody.propTypes = {
  children: PropTypes.node,
  flush: PropTypes.bool
};
UIPopoverBody.displayName = 'UIPopoverBody';